export default __webpack_public_path__ + "static/media/minus.95a850da.svg";